import * as ACTION from './amounts.actionTypes';

export const saveAmounts = (body) => async (dispatch) => {
    dispatch({
        type: ACTION.AMOUNTS_BUY_DEALER,
        result: body,
    })
};